// Fail-closed client gates for the Projects hub.

export const HUB_LENS = Object.freeze({
  PORTFOLIO: "portfolio",
  WEEKLY: "weekly",
  GANTT: "gantt",
  FINANCIALS: "financials",
  PEOPLE: "participants",
  SIGNALS: "signals",
  CONTRACTS: "contracts",
  RISK_REGISTER: "risk-register",
});

export function canViewHubFinancials(policy) {
  if (!policy || policy.ready !== true) return false;
  if (policy.role === "view_limited") return false;
  return typeof policy.canSee === "function" && policy.canSee("projects.budget") === true;
}

export function canExportHubFinancials(policy) {
  return canViewHubFinancials(policy)
    && policy.canSee("exports.portfolio.project_budgets") === true;
}

export function isActiveHubProject(project) {
  return Boolean(project) && project.phase !== "complete";
}

/** Local Monday (YYYY-MM-DD) of the week containing `now`. */
export function currentMondayIso(now = new Date()) {
  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const dow = d.getDay();
  d.setDate(d.getDate() - (dow === 0 ? 6 : dow - 1));
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}

export function formatWeekLabel(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || "");
  if (!m) return "Week unavailable";
  const d = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
  return `Week of ${d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" })}`;
}
